import Vue from 'vue';
import template from './reset-password.html';
import { DialogBox, dialogDefaultConfiguration, emittableValues } from "./dialog-box.mjs";
import { isEmailAddress } from "../helpers/emails.mjs";
import apiService from "../api.mjs";

const tagName = 'dialog-reset-password';

export const loginDialogDefinition = {
    ...dialogDefaultConfiguration,
    template: template,
};

Vue.component( tagName, loginDialogDefinition );

export const ERROR_NO_EMAIL      = 'Please enter an email address.';
export const ERROR_INVALID_EMAIL = 'Please enter a valid email address.';

export class ResetPasswordDialog extends DialogBox {

    constructor( email_address='' ) {
        super();
        this.email_address  = email_address;
        this.error_form     = null;
        this.error_email    = null;

        this.activeRequest = false;
        this.sent          = false;
    }

    getComponentTag() {
        return tagName;
    }

    getComponentData() {
        return {
            error_form    : this.error_form,
            error_email   : this.error_email,
            req_active    : this.activeRequest,
            sent          : this.sent
        };
    }

    onValueEmitted( value, ...values ) {
        if( value === emittableValues.CANCEL )
            this.close();
    }

    onResetButtonClick() {
        if( this.activeRequest )
            return;

        // Reset the state initially, and then we can test on these properties.
        this.error_form    = this.error_email = null;
        this.email_address = this.email_address
            .trim()
            .toLowerCase()
        ;

        if( !this.email_address ) {
            this.error_email = ERROR_NO_EMAIL;
        } else if( !isEmailAddress( this.email_address ) ) {
            this.error_email = ERROR_INVALID_EMAIL;
        }

        if( this.error_form || this.error_email )
            return true;

        // Send something?
        apiService.sendPasswordResetEmail( this.email_address )
            .then( () => this.sent = true )
            .catch( error => {
                console.warn('error', error);
                this.error_form = 'Something went wrong, please try again.';
            })

            .finally( () => {
                // Make sure we _definitely_ cancel the loading state, even if
                // an error gets thrown.
                this.activeRequest = false;
            })
        ;

        this.activeRequest = true;
    }

    onBeforeClose()
    {
        return (!this.activeRequest) || confirm("You're in the middle of a request. Abort?");
    }
}
